'use client';

import React, { useCallback, useRef } from 'react';

interface TouchSteerButtonsProps {
  onLeft: () => void;
  onRight: () => void;
}

export default function TouchSteerButtons({ onLeft, onRight }: TouchSteerButtonsProps) {
  const leftInterval = useRef<ReturnType<typeof setInterval> | null>(null);
  const rightInterval = useRef<ReturnType<typeof setInterval> | null>(null);

  const startLeft = useCallback((e: React.TouchEvent) => {
    e.preventDefault();
    onLeft();
    leftInterval.current = setInterval(onLeft, 50);
  }, [onLeft]);

  const stopLeft = useCallback(() => {
    if (leftInterval.current) {
      clearInterval(leftInterval.current);
      leftInterval.current = null;
    }
    window.dispatchEvent(new CustomEvent('surfsterre_tilt', { detail: { direction: 'center' } }));
  }, []);

  const startRight = useCallback((e: React.TouchEvent) => {
    e.preventDefault();
    onRight();
    rightInterval.current = setInterval(onRight, 50);
  }, [onRight]);

  const stopRight = useCallback(() => {
    if (rightInterval.current) {
      clearInterval(rightInterval.current);
      rightInterval.current = null;
    }
    window.dispatchEvent(new CustomEvent('surfsterre_tilt', { detail: { direction: 'center' } }));
  }, []);

  return (
    <>
      {/* Left steer */}
      <button
        className="btn-action hud-glass rounded-2xl flex items-center justify-center"
        style={{ width: '72px', height: '56px', borderColor: 'rgba(0,229,255,0.25)' }}
        onTouchStart={startLeft}
        onTouchEnd={stopLeft}
        onTouchCancel={stopLeft}
        aria-label="Steer left"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00e5ff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      {/* Right steer */}
      <button
        className="btn-action hud-glass rounded-2xl flex items-center justify-center"
        style={{ width: '72px', height: '56px', borderColor: 'rgba(0,229,255,0.25)' }}
        onTouchStart={startRight}
        onTouchEnd={stopRight}
        onTouchCancel={stopRight}
        aria-label="Steer right"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00e5ff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </>
  );
}